// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAwsgHmACCLdYkGh31Bi8vkH6QvOSfdDVA",
  authDomain: "webiste-builder-3306c.firebaseapp.com",
  projectId: "webiste-builder-3306c",
  storageBucket: "webiste-builder-3306c.firebasestorage.app",
  messagingSenderId: "883144769407",
  appId: "1:883144769407:web:1800b9d062e684da04644a"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);